import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RegionDto } from 'src/app/shared/dtos/user.dto';
import { transformAndValidatePipe } from 'src/app/shared/utils/operators';
import { catchError, Observable, of } from 'rxjs';
import { datadogLogs } from '@datadog/browser-logs';
import { BrowserInfo, getBrowserInfo } from 'src/app/core/utils/analytics.utils';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  http = inject(HttpClient);

  getUserRegions(): Observable<RegionDto[] | null> {
    return this.http.get<RegionDto[]>(`/api/user/regions`).pipe(
      transformAndValidatePipe(RegionDto),
      catchError((err: Error) => {
        datadogLogs.logger.error('Error fetching regions:', {}, err);

        return of(null);
      })
    );
  }

  setCurrentUserRegion(id: string): Observable<unknown> {
    return this.http.put(`/api/user/regions/set-current/${id}`, {});
  }

  getCurrentUsername(): Observable<string> {
    return this.http.get<string>(`/api/user/username`);
  }
  
  updateUserDetails(body: BrowserInfo = getBrowserInfo()): Observable<void | undefined> {
    return this.http.post<void>('/api/update-user-details', body).pipe(
      catchError((err: Error) => {
        datadogLogs.logger.error('Error updating user details:', { body }, err);
        return of(undefined);
      })
    );
  }
}
